function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const lastTabs = [
  {
    id: NaN,
    title: 'Сводка',
    index: 1
  },
  {
    id: NaN,
    title: 'План действий',
    index: 2
  }
];

type TabsListProps = {
  data: { [key: string]: string | number }[];
  value: { [key: string]: string | number };
  isFixed?: boolean;
  onChange: (newValue: { [key: string]: string | number }) => void;
};

function TabsList({ data, value, isFixed, onChange }: TabsListProps) {
  const currentData = data.concat(lastTabs);

  return (
    <ul
      aria-label="Tabs"
      className={`${isFixed && 'sticky top-0 z-20'} mb-1 flex justify-between space-x-2 rounded-md bg-white p-1 shadow`}
    >
      {currentData.map((tab, index) => (
        <li
          key={index}
          className={classNames(
            value.title === tab.title ? 'bg-gray-50 text-black' : 'text-gray-500',
            'cursor-pointer rounded-md px-3 py-3 text-sm font-medium',
          )}
          onClick={() => onChange(tab)}
        >
          {tab.title}
        </li>
      ))}
    </ul>
  );
}

export default TabsList;
